import { Checkbox } from "@/components/ui/checkbox.tsx";
import type { ArgumentInputProps } from './types';

export function CheckboxInput({ arg, onChange }: ArgumentInputProps) {
  return (
    <div className="grid gap-2">
      <label className="font-medium text-detail text-gray-700 cursor-pointer flex items-center gap-2">
        <Checkbox
          checked={arg.value === true}
          onCheckedChange={(ch) => onChange(ch === true)}
        />
        <span>{arg.name.replace(/_/g, ' ')}</span>
      </label>
      {arg.description && (
        <p className="text-detail text-gray-500 ml-6">{arg.description}</p>
      )}
    </div>
  );
}